/* import __COLOCATED_TEMPLATE__ from './setup.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
/* eslint-disable ember/no-empty-glimmer-component-classes */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type ApiConfiguration from 'embercom/models/standalone/api-configuration';
import type LivePersonConfiguration from 'embercom/models/standalone/live-person-configuration';
import type Store from '@ember-data/store';
import type AppService from 'embercom/services/app-service';

interface Args {
  apiConfig: ApiConfiguration;
}

export default class StandaloneApiSetup extends Component<Args> {
  @service declare store: Store;
  @service declare appService: AppService;
  @tracked openSectionId?: string;
  @tracked livePersonConfig?: LivePersonConfiguration;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.loadLivePersonConfig();
  }

  async loadLivePersonConfig() {
    try {
      this.livePersonConfig = await this.store.findRecord(
        'standalone/live-person-configuration',
        this.appService.app.id,
      );
    } catch (error) {
      this.livePersonConfig = this.store.createRecord('standalone/live-person-configuration', {
        username: '',
        appKey: '',
        secret: '',
        accessToken: '',
        accessTokenSecret: '',
        accountId: '',
        tokenId: null,
        escalationSkill: '',
        disableJwtVerification: false,
        configured: false,
      });
    }
  }

  @action setOpenSectionId(id: string | undefined) {
    this.openSectionId = id;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::CustomChannelApi::Setup': typeof StandaloneApiSetup;
    'standalone/custom-channel-api/setup': typeof StandaloneApiSetup;
  }
}
